import React from "react";

export default ({ fill = "#0062ff" }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.53027 1.23145L8 1.58887V2.84473L7.22949 2.25781L2.65137 5.76367V13.499H11.6514V11H12.6514V14.499H1.65137V6.5293L0.607422 7.3291L0.303711 6.93262L0 6.53516L6.92383 1.23242L7.22656 1L7.53027 1.23145Z"
            fill={fill}
        />
        <line y1="-0.5" x2="7" y2="-0.5" transform="matrix(-1 0 0 1 16 3.5)" stroke={fill} />
        <line y1="-0.5" x2="7" y2="-0.5" transform="matrix(-1 0 0 1 16 6.5)" stroke={fill} />
        <line y1="-0.5" x2="7" y2="-0.5" transform="matrix(-1 0 0 1 16 9.5)" stroke={fill} />
        <circle cx="1" cy="1" r="0.5" transform="matrix(-1 0 0 1 15 2)" fill={fill} stroke={fill} />
        <circle cx="1" cy="1" r="0.5" transform="matrix(-1 0 0 1 10 5)" fill={fill} stroke={fill} />
        <circle cx="1" cy="1" r="0.5" transform="matrix(-1 0 0 1 12 8)" fill={fill} stroke={fill} />
    </svg>
);
